<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ form?.customer?.id ? "Modifica" : "Nuovo" }} Customer</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>


<app-customer-form></app-customer-form>